<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="none">
        <path
            d="M14.2866 4.57129H1.71512C1.08394 4.57129 0.572266 5.08297 0.572266 5.71415V14.2856C0.572266 14.9168 1.08394 15.4284 1.71512 15.4284H14.2866C14.9178 15.4284 15.4294 14.9168 15.4294 14.2856V5.71415C15.4294 5.08297 14.9178 4.57129 14.2866 4.57129Z"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M1.56641 4.57129L15.4293 0.571289"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M5.14397 13.1429C6.09075 13.1429 6.85826 12.3754 6.85826 11.4286C6.85826 10.4819 6.09075 9.71436 5.14397 9.71436C4.1972 9.71436 3.42969 10.4819 3.42969 11.4286C3.42969 12.3754 4.1972 13.1429 5.14397 13.1429Z"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M10.8574 10H12.5717"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M10.8574 12.8569H12.5717"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M0.572266 7.42822H15.4294"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
</template>
